export default __webpack_public_path__ + "static/media/us.0e0ec41f.png";